const state = {
    subjectStatusList: [], // 题目列表
    currentSubjectIndex: 0, // 当前题目索引值
    examIllustrate: '', // 考试说明
    examTicket: {}, // 准考证数据
    signExamDetail: {} // 报考信息
}

const mutations = {
    setSubjectStatusList (state, arr) {
        state.subjectStatusList = JSON.parse(JSON.stringify(arr))
    },
    setCurrentSubjectIndex (state, num) {
        state.currentSubjectIndex = num
    },
    setExamIllustrate (state, str) {
        state.examIllustrate = str
    },
    setExamTicket (state, obj) {
        state.examTicket = obj
    },
    setSignExamDetail (state, obj) {
        state.signExamDetail = obj
    }
}

const getters = {
    subjectStatusList: state => state.subjectStatusList,
    currentSubjectIndex: state => state.currentSubjectIndex,
    examIllustrate: state => state.examIllustrate,
    examTicket: state => state.examTicket,
    signExamDetail: state => state.signExamDetail
}

export default { namespaced: true, state, mutations, getters }



// WEBPACK FOOTER //
// ./src/store/modules/subject.js